var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "club-points-history-table-row" },
    [
      _c("points", {
        attrs: { value: _vm.points, "is-add-mode": _vm.isAddMode }
      }),
      _c("cell-label", { staticClass: "club-points-history-table-row__date" }, [
        _vm._v("\n    Операция от " + _vm._s(_vm.date) + "\n  ")
      ]),
      _vm.isAddMode
        ? _c(
            "div",
            { staticClass: "club-points-history-table-row__table" },
            [
              _c("cell-label", [_vm._v("\n      Остаток\n    ")]),
              _c("cell-value", [
                _vm._v("\n      " + _vm._s(_vm._f("price")(_vm.sum)) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "club-points-history-table-row__table" },
        [
          _c("cell-label", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.isAddMode ? "Начисление" : "Списание") +
                "\n    "
            )
          ]),
          _c(
            "cell-value",
            [
              _c("history-description", {
                attrs: {
                  description: _vm.description,
                  "order-number": _vm.orderNumber,
                  receipt: _vm.receipt
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.isAddMode
        ? _c(
            "div",
            { staticClass: "club-points-history-table-row__table" },
            [
              _c("cell-label", [_vm._v("\n      Сгорают\n    ")]),
              _c("cell-value", [
                _vm._v("\n      " + _vm._s(_vm.burnsAt) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }